import { h } from 'preact';
import * as BaseComp from 'components/bolt/nativeVideo/nativeVideo.js';
// import s from 'components/bolt/nativeVideo/nativeVideo.sss';
import Store from 'store/store';

export default class NativeVideo extends BaseComp.default {

	progressTracker() {
	

		if (!this.trackProgress || !this.$video) {
			// We shouldn't be tracking the progress, so let's quit
			return;
		}

		// Only update the state progress if displaying the controls
		// if (this.props.showControls) {
		// 	this.setState({ progress: this.$video.currentTime });
		// }

		const progress = this.$video.currentTime / this.$video.duration;

		let step = [0, 25, 50, 75, 95].find(step => progress > (step / 100) && !this.progressTracking[step]);

		

		if (step || step === 0) {
			this.progressTracking[step] = true;

			Store.emit('CUSTOM_EVENT', {
				category: this.props.pageId,
				action: 'videos-completion',
				label: this.props.activeVideo.title + '_' + this.videoName + '_' + step + ' percent complete_' + this.$video.currentTime
			});

			Store.emit('VIDEO_PLAYER_PROGRESS', {
				step,
				video: this.videoName,
				time: this.$video.currentTime,
				platform: 'native',
				isShowtimesMessage: this.props.isShowtimesMessage,
				isTrailerOverlay: this.props.isTrailerOverlay,
				isTrailer: this.props.isTrailer
			});
		}
		Store.emit('EMBEDDED_VIDEO_PLAY');

		this.timer = requestAnimationFrame(this.progressTracker);
	}

}
